import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player/lazy'
import EdulasticResourceModal from '../common/EdulasticResourceModal'
import { sanitizeRawUrl } from '../WebsiteResourceModal'
import TokenizedYouTubePlayer from '../../../../../../common/components/TokenizedYouTubePlayer'

/**
 * EmbeddedVideoPreviewModal modal to preview embedded video links
 * Each Service has their own format of embedding videos in iframe
 * Current Support for external video links (Youtube,Vimeo, GDrive public shared)
 */

const EmbeddedVideoPreviewModal = (props) => {
  const { isVisible } = props
  const { title = '', url = '' } = isVisible || {}

  const youtubeService = () => {
    return (
      <EdulasticResourceModal
        headerText={title}
        {...props}
        maxWidth="645px"
        hideFooter
        smallFont
      >
        {/* Tokenized v2 player so it plays on domains where YouTube enforces
            Embedder Identity (tokenless iframes fail with error 152). */}
        <TokenizedYouTubePlayer
          url={url}
          width="560px"
          height="315px"
          playerVars={{
            utm_source: 'Application',
            utm_medium: 'Clicks',
            utm_campaign: 'Dashboard_Quick_Start_Overview',
          }}
        />
      </EdulasticResourceModal>
    )
  }

  const vimeoService = () => {
    // Matches Various patterns of vimeo links and extracts video ID
    const regExp = /^.*(?:vimeo.com)\/(?:channels\/|channels\/\w+\/|groups\/[^/]*\/videos\/|album\/\d+\/video\/|video\/|)(\d+)(?:$|\/|\?)/
    const match = url.match(regExp)
    return (
      <EdulasticResourceModal
        headerText={title}
        {...props}
        maxWidth="720px"
        hideFooter
        smallFont
      >
        <iframe
          title={title || 'Vimeo video preview'}
          width="640"
          height="360"
          src={`https://player.vimeo.com/video/${match[1]}`}
          frameBorder="0"
          allow="autoplay; fullscreen"
          style={{ margin: 'auto' }}
          allowFullScreen
        />
      </EdulasticResourceModal>
    )
  }

  const googleDriveService = () => {
    return (
      <EdulasticResourceModal
        headerText={title}
        {...props}
        maxWidth="720px"
        hideFooter
        smallFont
      >
        <iframe
          title={title || 'Google Drive video preview'}
          width="640"
          height="480"
          src={url}
          style={{ margin: 'auto' }}
        />
      </EdulasticResourceModal>
    )
  }

  const awsService = () => {
    return (
      <EdulasticResourceModal
        headerText={title}
        {...props}
        maxWidth="730px"
        hideFooter
        smallFont
        modalWidth="730px"
      >
        <ReactPlayer controls width="640px" url={url} />
      </EdulasticResourceModal>
    )
  }

  if (url.search(/youtu\.?be(\.com)?\//) !== -1) {
    return youtubeService()
  }
  if (url.includes('vimeo.com')) {
    return vimeoService()
  }
  if (url.includes('drive.google.com')) {
    return googleDriveService()
  }
  if (url.includes('cloudfront.net') || url.includes('videos.edulastic.com')) {
    return awsService()
  }
  return (
    <EdulasticResourceModal
      headerText={title}
      {...props}
      maxWidth="720px"
      hideFooter
      smallFont
    >
      <iframe
        title={title || 'Video preview'}
        width="720px"
        height="405px"
        src={sanitizeRawUrl(url)}
        frameBorder="0"
        allowFullScreen
      />
    </EdulasticResourceModal>
  )
}

EmbeddedVideoPreviewModal.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

export default EmbeddedVideoPreviewModal
